import { getTags } from "../../../api/TagsAPI";
import { useLanguage } from "../../../stores/LanguageStore";
import TagsCell from "./TagsCell";

export const tagsColumn = ({
  apiRef,
  editFunction,
  wrapperProps,
  onEdited,
  handleFilter,
  field = "tags",
  filterable,
  flex,
  sortable,
}) => {
  const lang = useLanguage.getState().language
  return {
    field,
    headerName: "Tags",
    width: 200,
    cellClassName: "hover-source",
    filterable,
    sortable,
    flex,
    valueGetter: (params) => {
      if (params.value) return params.value.map((e) => e.name).join(", ");
      return null;
    },
    renderCell: (cell) => (
      <TagsCell
        cell={cell}
        apiRef={apiRef}
        editFunction={editFunction}
        wrapperProps={wrapperProps}
        onEdited={onEdited}
        handleFilter={handleFilter}
        field={field}
      />
    ),
    conditions: [
      {
        value: "contains",
        label: lang.table.toolbar.filter.filters_list_label.server.contains,
      },
      {
        value: "isEmpty",
        label:
          lang.table.toolbar.filter.filters_list_label.server.does_not_exist,
      },
      {
        value: "isNotEmpty",
        label: lang.table.toolbar.filter.filters_list_label.server.does_exist,
      },
    ]
  };
};
